import { combineReducers } from '@reduxjs/toolkit';
import data from './dataSlice';
import state from './stateSlice';

const crmCustomerDetails = combineReducers({
  state,
  data,
});

export default crmCustomerDetails;
